module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00696.148ed90b.jpg";